import { Box } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import LoadingButton from "../../../../components/loading/button";
import { node_server } from "../../../../constants";
import { setPublicSkills } from "../../../../store/slices/profile/publicUserSlice";
import AboutSkill from "./components/about";
import SkillCoverImage from "./components/cover-image";
import SkillsBar from "./components/skills-bar";
import SkillStatus from "./components/status";
import styles from "./style.module.css";

function MySkills() {
	const { id } = useParams();
	const [activeSkill, setActiveSkill] = useState(null);
	const dispatch = useDispatch();
	const skills = useSelector((state) => state.publicUser.skills);

	const fetchSkills = async () => {
		const { data, error } = await axios.get(
			`${node_server}/api/user/user-skills`,
			{
				withCredentials: true,
			},
		);
		if (error) console.log(error);
		if (data) {
			if (!activeSkill) {
				setActiveSkill(data.length > 0 ? data[0] : null);
			}
			data.sort((a, b) => a.id - b.id);
			dispatch(setPublicSkills(data));
		}
	};

	useEffect(() => {
		if (id) fetchSkills();
	}, [id]);

	if (!skills)
		return (
			<div className={styles.loading}>
				<LoadingButton />
			</div>
		);

	return (
		<Box className={styles.mySkills}>
			<SkillsBar
				activeSkill={activeSkill}
				setActiveSkill={setActiveSkill}
			/>
			<SkillCoverImage skill={activeSkill} />
			<SkillStatus skill={activeSkill} />
			<AboutSkill skill={activeSkill} />
		</Box>
	);
}

export default MySkills;
